<template>
    <div>
        <b-card class="mt-2 mb-0 smallinputs" header-tag="header" footer-tag="footer" border-variant="success">

            <b-card-body class="mt-2 py-0 px-0">
                <b-tabs class="gridtabs" v-model="tabindex">

                    <b-tab active>
                        <template #title>
                            <i class="fa fa-handshake-o text-primary mr-2"></i><span class="strong">{{ value.slac }} |
                                {{ value.slacname
                                }} | {{ value.eventcode }} | {{ value.eventname }}</span>
                        </template>

                        <p class="py-3 px-0">
                            <b-row>
                                <b-col>
                                    <div class="mt-0 mb-1 text-center">
                                        <table class="w-100pct">
                                            <tr class="header-dark mb-1">
                                                <td role="columnheader" scope="col" aria-colindex="1"
                                                    class="table-b-table-default text-center w-25px">
                                                    <input style="height: 15px; margin-top: 2px" type="checkbox"
                                                        :checked="true" :disabled="true" />
                                                </td>
                                                <td colspan="2" class="text-center">Travellers</td>
                                                <td class="" style="width:33%">Traveller</td>
                                                <td class="" style="width:33%">Your Ref / PO</td>
                                                <td @click="cliplines()">RefNo <i @click="cliplines()"
                                                        :id="'lines-copy_' + value.id"
                                                        class="fa fa-clipboard hover-primary" title="Copy"></i></td>
                                                <b-tooltip :target="'lines-copy_' + value.id" placement="top">Copy
                                                    selected lines to the clipboard</b-tooltip>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td class="w-30px">
                                                    <b-input-group class="m-auto w-15px">
                                                        <input id="travellerCheck" style="height: 13px" type="checkbox"
                                                            :checked="true" :value="true" :disabled="true" />
                                                    </b-input-group>
                                                </td>
                                                <td class="w-30px"> <span class="small text-primary">{{ 0 + 1
                                                }}.</span></td>
                                                <td class="w-30px"> <i class="fa fa-user text-primary mr-2"></i></td>
                                                <td>
                                                    <b-form-group class="mb-3px">
                                                        <b-input-group>
                                                            <b-form-input size="sm" v-model="value.lines[0].passenger"
                                                                placeholder="Passenger" :formatter="onlyascii"
                                                                trim></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    @click="value.lines[0].passenger = ''">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </td>
                                                <td>
                                                    <b-form-group class="mb-3px">
                                                        <b-input-group>
                                                            <b-form-input size="sm" v-model="value.yourref"
                                                                placeholder="P/O" :formatter="onlyascii"
                                                                trim></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    @click="value.yourref = ''">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </td>
                                                <td>{{ value.referenceno }}</td>
                                                <td></td>
                                            </tr>

                                        </table>
                                    </div>

                                    <div class="mt-2 mb-1 text-center">
                                        <table class="w-100pct">
                                            <tr class="header-dark ">
                                                <td role="columnheader" scope="col" aria-colindex="1"
                                                    class="table-b-table-default text-center w-25px">

                                                    <input id="linesAll" style="height: 15px; margin-top: 2px"
                                                        type="checkbox" :checked="allLinesChecked" @change="linesAll"
                                                        :disabled="value.lines.length == 1 || value.lines.filter(o => o.sale != 'N/A').length == 1" />
                                                </td>
                                                <td colspan="2" class="text-center">Lines </td>
                                                <td> DateTravel</td>
                                                <td> RefNo </td>
                                                <td> Traveller </td>
                                                <td> Description </td>

                                                <td> PAYBY </td>
                                                <td> BLAC </td>
                                                <td> Cost </td>
                                                <td> CUR </td>
                                                <td> Margin</td>
                                                <td> Agent </td>
                                                <td> Qty </td>
                                                <td> Sale GBP </td>
                                                <td> VAT GBP </td>
                                                <td> Amount GBP</td>

                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td colspan="2"></td>
                                                <td> </td>
                                                <td> </td>
                                                <td> </td>
                                                <td> </td>
                                                <td> </td>
                                                <td> </td>
                                                <td> </td>
                                                <td> </td>
                                                <td> </td>
                                                <td> </td>
                                                <td> </td>
                                            </tr>
                                            <tr v-for="(line, index) in value.lines" :key="index">

                                                <td class="w-30px">
                                                    <b-input-group class="m-auto w-15px">
                                                        <input id="lineCheck" style="height: 12px" type="checkbox"
                                                            v-model="lines" @click="toggleLine($event, index)"
                                                            :checked="true" :value="line"
                                                            :disabled="value.lines.length == 1 || line.fare == 'N/A' || value.lines.filter(o => o.fare != 'N/A').length == 1" />

                                                    </b-input-group>
                                                </td>
                                                <td class="w-30px">
                                                    <span class="small text-primary">{{ index + 1 }}.</span>
                                                </td>
                                                <td class="w-30px">
                                                    <i :class="icontype(line.type)" class="mr-2" :title="line.type"></i>
                                                </td>

                                                <td>
                                                    <div class=" form-control form-control-sm disabled">{{
                                                        $moment(line.start_at).utc(true).format('dd DD/MM/YY')
                                                        }}</div>

                                                </td>
                                                <td>
                                                    <div class="text-center form-control form-control-sm disabled">
                                                        {{ line.referenceno }}</div>
                                                </td>
                                                <td class="w-10pct">
                                                    <b-form-group>
                                                        <!-- background-color:#d8dbe0; -->
                                                        <b-form-textarea
                                                            :style="'min-height:22px !important; font-size:12px; color:#549c60 !important; padding:0; padding-left:1px '"
                                                            v-model="line.passenger"></b-form-textarea>
                                                    </b-form-group>
                                                </td>
                                                <!-- class="min-w-250px" -->
                                                <td class="w-25pct">
                                                    <b-form-group>
                                                        <!-- background-color:#d8dbe0; -->
                                                        <b-form-textarea
                                                            :style="'min-height:22px !important; font-size:12px; color:#549c60 !important; padding:0; padding-left:1px '"
                                                            v-model="line.details"></b-form-textarea>
                                                    </b-form-group>
                                                    <!-- <div
                                                        class="w-300px ellipsis text-left form-control form-control-sm disabled">
                                                        {{
                    line.description
                }}</div> -->
                                                </td>


                                                <td>
                                                    <div class="text-center form-control form-control-sm disabled">
                                                        {{ line.payby }}</div>

                                                    <!-- <b-form-group class="mb-3px">
                                                        <b-input-group>
                                                            <b-form-input size="sm" v-model="line.payby"
                                                                placeholder="PayBy" class="text-right"
                                                                :formatter="nocomma" :disabled="false"></b-form-input>
                                                        </b-input-group>
                                                    </b-form-group> -->
                                                </td>
                                                <td class="w-10pct">
                                                    <b-form-group class="mb-3px">
                                                        <b-input-group>
                                                            <b-form-input size="sm" v-model="line.blac"
                                                                placeholder="BL A/C" class="text-right"
                                                                :formatter="nocomma" :disabled="false"></b-form-input>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </td>
                                                <td class="w-6pct">
                                                    <b-form-group class="mb-3px">
                                                        <b-input-group>
                                                            <b-form-input size="sm" v-model="line.cost"
                                                                placeholder="Cost" class="text-right"
                                                                :formatter="nocomma" :disabled="false"></b-form-input>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </td>
                                                <td>
                                                    <div class="text-center form-control form-control-sm disabled">
                                                        {{ line.currency }}</div>
                                                    <!-- <span :class="'flag-icon flag-icon-gb'"></span> -->
                                                </td>
                                                <td>
                                                    <div class="text-center form-control form-control-sm disabled">
                                                        <span class="strong"
                                                            :style="parseFloat(line.margin) <= 0 ? 'color:red' : 'color:#3cb450'">{{
                                                            line.margin }} %</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="text-center form-control form-control-sm disabled">
                                                        {{ line.agent }}</div>
                                                </td>
                                                <td>
                                                    <div
                                                        class="w-50px text-center form-control form-control-sm disabled">
                                                        {{ line.qty }}</div>
                                                </td>

                                                <td class="w-6pct">
                                                    <!-- <b-form-group class="mb-3px">
                                                        <b-input-group>
                                                            <b-form-input size="sm" v-model="line.sale"
                                                                placeholder="Sale" class="text-right" :disabled="true"
                                                                trim></b-form-input>
                                                        </b-input-group>
                                                    </b-form-group> -->
                                                    <b-form-group class="mb-3px">
                                                        <b-input-group>
                                                            <b-form-input size="sm" v-model="line.sale"
                                                                placeholder="Sale" class="text-right"
                                                                :formatter="nocomma" :disabled="false"></b-form-input>
                                                            <!-- :disabled="sector.total == 'N/A' ? true : false" -->
                                                        </b-input-group>
                                                    </b-form-group>

                                                </td>
                                                <td class="w-6pct">
                                                    <!-- <b-form-group class="mb-3px">
                                                        <b-input-group>
                                                            <b-form-input size="sm" v-model="line.vat" placeholder="VAT"
                                                                class="text-right" :disabled="true"
                                                                :formatter="nocomma"></b-form-input>
                                                        </b-input-group>
                                                    </b-form-group> -->
                                                    <b-form-group class="mb-3px">
                                                        <b-input-group>
                                                            <b-form-input size="sm" v-model="line.vat" placeholder="VAT"
                                                                class="text-right" :formatter="nocomma"
                                                                :disabled="false"></b-form-input>
                                                            <!-- :disabled="sector.total == 'N/A' ? true : false" -->
                                                        </b-input-group>
                                                    </b-form-group>
                                                </td>
                                                <td class="w-6pct">
                                                    <b-form-group class="mb-3px">
                                                        <b-input-group>
                                                            <b-form-input size="sm" v-model="line.total"
                                                                placeholder="Total" class="text-right"
                                                                :formatter="nocomma" :disabled="true"></b-form-input>
                                                            <!-- :disabled="sector.total == 'N/A' ? true : false" -->
                                                        </b-input-group>
                                                    </b-form-group>
                                                </td>
                                            </tr>
                                            <!-- <tr>
                                                <td class="w-30px">
                                                    <i class="fa fa-plus-square text-secondary" @click="addLine"></i>
                                                </td>
                                            </tr> -->
                                            <tr>
                                                <td colspan="13" class="pr-1 text-right"></td>

                                                <td><span class="h6 strong">Total</span></td>
                                                <td>
                                                    <b-form-group class="mb-3px">
                                                        <b-input-group>
                                                            <b-form-input size="sm" v-model="value.sale"
                                                                placeholder="Net" class="text-right strong"
                                                                :disabled="true" :formatter="nocomma"></b-form-input>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </td>
                                                <td>
                                                    <b-form-group class="mb-3px">
                                                        <b-input-group>
                                                            <b-form-input size="sm" v-model="value.vat"
                                                                placeholder="Tax" class="text-right strong"
                                                                :disabled="true" :formatter="nocomma"></b-form-input>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </td>
                                                <td>
                                                    <b-form-group class="mb-3px">
                                                        <b-input-group>
                                                            <b-form-input size="sm" v-model="value.total"
                                                                placeholder="Total" class="text-right strong"
                                                                :disabled="true" :formatter="nocomma"></b-form-input>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </td>
                                                <td></td>
                                            </tr>
                                            <tr v-if="1 == 0">
                                                <td colspan="12" class="pr-1 text-right"><span class="h6 strong">Admin
                                                        Fee</span></td>
                                                <td>
                                                    <b-form-group>
                                                        <b-input-group>
                                                            <b-form-input size="sm" v-model="value.adminfee"
                                                                placeholder="Admin Fee" class="text-right strong"
                                                                :formatter="nocomma"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    @click="value.adminfee = '0.00'">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>

                                </b-col>
                            </b-row>
                            <!-- {{ travellers }} -->
                            <!-- {{ value.total }} -->
                            <!-- {{ segments }} -->
                            <!-- {{ value.vat }} -->
                        </p>
                    </b-tab>

                    <b-tab>
                        <template #title>
                            <i class="fa fa-wpforms text-primary mr-1"></i> Draft
                        </template>
                        <p class="py-3 px-0">
                        <div class="etr">
                            <b-row>
                                <b-col cols="12">
                                    <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary" rounded="sm">
                                        <r-invoice :showasdraft="true" :item="item" />
                                        <b-alert v-if="item.message" show :variant="item.level"
                                            class="text-center mt-2 mb-1">
                                            <b-row align-v="center" no-gutters class="font-13px"><b-col
                                                    cols="auto mr-3">
                                                    <i class="fa fa-info-circle fa-2x"></i></b-col>
                                                <b-col> <span
                                                        v-html="item.message.split('\n').join('<br/>')"></span></b-col></b-row>
                                        </b-alert>
                                    </b-overlay>
                                    <b-card-footer class="mt-2 ml-1">
                                        <b-row>
                                            <b-col class="text-left">
                                                <b-row class="mt-1">
                                                    <b-col>
                                                        <b-button squared size="sm" class="ml-1" variant="warning"
                                                            @click="showledgers = !showledgers" :pressed="!showledgers">
                                                            Ledgers<i :class="showledgers ? 'fa fa-arrow-up ml-1' : 'fa fa-arrow-down ml-1'
                                                                "></i>
                                                        </b-button>
                                                    </b-col>
                                                    <b-col>
                                                        <div v-if="busy">
                                                            <i class="fa fa-spinner fa-spin text-primary"></i>
                                                            <span class="text-success ml-2">Preparing set of
                                                                invoice(s)</span>
                                                        </div>
                                                        <div v-else>
                                                            <span v-html="message"></span>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col class="text-right">
                                                <b-button-group class="z-0" v-if="items.length > 1">
                                                    <b-button squared size="sm" @click="render()"
                                                        variant="outline-primary" class="mr-1 h-28px">
                                                        <i class="fa fa-refresh"></i>
                                                    </b-button>

                                                    <b-pagination hide-ellipsis v-model="page"
                                                        :total-rows="items.length" :per-page="1" align="right"
                                                        size="sm"></b-pagination>
                                                </b-button-group>


                                            </b-col>

                                        </b-row>

                                    </b-card-footer>
                                    <div v-if="showledgers" class="mx-4">
                                        <b-row>
                                            <b-card class="border-none w-100pct">
                                                <b-card-title class="text-left">B/L Item Headers</b-card-title>
                                                <d-table classdivtable="availtable datatable" refid="blitemheaders"
                                                    :items="data.BL" :showpages="false" :showtoolbar="false">
                                                </d-table>
                                            </b-card>
                                        </b-row>
                                        <b-row>
                                            <b-card class="border-none w-100pct">
                                                <b-card-title class="text-left">S/L Item Headers</b-card-title>
                                                <d-table classdivtable="availtable datatable" refid="blitemheaders"
                                                    :items="SL" :showpages="false" :showtoolbar="false">
                                                </d-table> </b-card></b-row>
                                        <b-row>
                                            <b-card class="border-none w-100pct">
                                                <b-card-title class="text-left">l Item Lines</b-card-title>
                                                <d-table classdivtable="availtable datatable" refid="blitemheaders"
                                                    :items="data.SL[0].items" :showpages="false" :showtoolbar="false">
                                                </d-table> </b-card></b-row>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                        </p>
                    </b-tab>
                    <b-tab @click="refno = refno_options[0].id">
                        <template #title>
                            <i class="fa fa-plus-square text-primary mr-1"></i> Additional
                        </template>
                        <b-row class="mt-2">
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="CreditNo ( Invoice to Credit )" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="creditno" :debounce="500"
                                            placeholder="CreditNo"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" squared variant="outline-secondary"
                                                @click="creditno = null">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="TicketNo ( for Costs )" label-for="ticketno" label-cols="12">
                                    <b-input-group>
                                        <b-form-input type="text" v-model="ticketno" placeholder="Enter ticketno"
                                            trim></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" @click="ticketno = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Routing" label-for="routing" label-cols="12">
                                    <b-input-group>
                                        <b-form-input type="text" v-model="routing" placeholder="Enter routing"
                                            trim></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" @click="routing = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row class="mt-2">
                            <b-col cols="12">
                                <b-form-group
                                    :label="'Conferma IDs for invoice lines ( count: ' + confermano.length + ' )'"
                                    label-for="id" label-cols="12">
                                    <b-input-group class="z-0">
                                        <b-form-tags input-id="id" v-model="confermano" class="min-h-29"
                                            tag-variant="primary" separator=" ,;" placeholder="Paste ID (333..,333...)"
                                            size="sm" add-button-text="+" add-on-change remove-on-delete
                                            add-button-variant="outline-primary"></b-form-tags>

                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" @click="confermano = []">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <p>

                            <b-row no-gutters class="my-2">
                                <b-col class="divider"></b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label-cols="12" label="RefNo" label-size="sm">
                                        <treeselect id="refno" placeholder="Select refno..." :clearable="false"
                                            v-model="refno" :options="refno_options" :disable-branch-nodes="true"
                                            :show-count="true" />
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12">
                                    <b-form-group label="Original Notes" label-for="notes" label-cols="12">
                                        <b-form-textarea id="notes" v-model="notes" placeholder="Notes" rows="8"
                                            max-rows="8" class="smalltextarea" :disabled="false"></b-form-textarea>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </p>
                    </b-tab>

                </b-tabs>

            </b-card-body>

            <!-- posted={{ value.posted }} -->

            <template #footer>
                <b-row>
                    <b-col cols="auto" class="text-left">
                        <b-button squared size="sm" :variant="postit_variant"
                            :disabled="value.posted || postit_variant == 'dark'" @click="postit">
                            <i :class="postit_icon"></i>
                            {{ postit_label }}
                        </b-button>

                        <!-- <b-button v-if="!draft" squared size="sm"
                            :variant="busy ? 'warning' : parseFloat(value.total) <= 0 ? 'danger' : 'primary'"
                            :disabled="busy || parseFloat(value.total) <= 0 || value.posted || lines.length == 0"
                            @click="postit">
                            <div v-if="busy">
                                <i class="fa fa-spinner fa-spin text-white mr-1"></i>
                                <span class="text-white" v-html="'Posting to Ledgers'"></span>
                            </div>
                            <div v-else>
                                <i :class="value.posted ? 'fa fa-stack-overflow mr-1' : 'fa fa-paper-plane mr-1'"></i>
                                <span
                                    v-html="value.posted ? 'Invoiced on ' + items.map(l => l.ref).sort().join(',') : 'Post It'"></span>
                            </div>
                        </b-button> -->
                    </b-col>
                    <!-- <b-col cols="auto" class="text-left" v-if="lines.length > 1">
                        <input id="perline" style="height: 15px; margin-top: 3px" type="checkbox" v-model="perline"
                            :disabled="value.posted">
                        <span class="ml-2" @click="perline = !perline">Invoice per line</span>
                    </b-col> -->
                    <b-col align-self="center"><span v-if="!value.posted && !busy && !draft"
                            v-html="readymessage"></span> </b-col>
                    <b-col cols="auto">
                        <b-row>
                            <b-col cols="auto" align-self="center">
                                <h5 :class="ZColour">
                                    {{ ZTotal }}
                                </h5>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </template>

        </b-card>
    </div>
</template>

<script>
import gql from "graphql-tag";

export default {
    name: "i-linvoice",
    data() {
        return {
            tabindex: 0,
            message: "",
            busy: false,
            draft: false,
            perline: false,
            refno: null,
            creditno: null,
            ticketno: null,
            routing: null,
            confermano: [],
            notes: null,
            refno_options: [],
            lines: [],
            page: 1,
            level: ["success"],
            ss: [],
            items: [],
            item: {
                ref: ""
            },
            data: null,
            SL: [],
            showledgers: false,
            prefix: "IM",
            level: ["success"],
            options_prefix: [
                { id: "IM", label: "IM | Manual " },
                { id: "CM", label: "CM | Credit" },
            ],
            options_level: [
                { id: "success", label: "Success" },
                { id: "warning", label: "Warning" },
                { id: "danger", label: "Danger" },
            ],
        };
    },
    props: {
        value: { type: Object, required: true },
        title: { type: String, default: "" },
    },
    computed: {
        readymessage() {
            return (
                "<span class='text-primary'>Ready to submit " +
                this.invoicecount +
                " document(s).</span>"
            );
        },
        invoicecount() {
            return this.perline ? this.value.lines.length : 1;
            if (this.value.passengers) {
                let yourrefs = [
                    ...new Set(
                        this.value.passengers.map((item) =>
                            item.yourref ? item.yourref : null
                        )
                    ),
                ];
                count = yourrefs.length;
            }
            return count;
        },
        ZTotal() {
            let sale = 0.0;
            let vat = 0
            for (var i = 0; i < this.lines.length; i++) {
                if (this.lines[i].sale != "N/A") {
                    sale += parseFloat(this.lines[i].sale);
                    this.lines[i].total = this.lines[i].sale
                }
                if (this.lines[i].vat != "N/A") {
                    vat += parseFloat(this.lines[i].vat);
                }
            }

            this.value.sale = sale.toFixed(2)
            this.value.vat = vat.toFixed(2)

            this.value.total = (parseFloat(sale) + parseFloat(vat)).toFixed(2)

            let total = parseFloat(sale) + parseFloat(vat)

            return (
                this.lines.length + " lines * ( " + sale.toFixed(2) + " = " + (sale).toFixed(2) + " ) = GBP " +
                total.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            );
        },
        ZColour() {
            let result = "text-primary"
            if (parseFloat(this.value.total) <= 0) {
                result = "text-danger"
            }
            result += " strong mb-0"
            return result
        },
        allLinesChecked() {
            const checked = this.lines.length;
            // // console.log("allAreChecked?", checked);
            return checked === this.value.lines.length
        },
        postit_variant() {
            if (this.busy) {
                return 'warning'
            } else {
                if (parseFloat(this.value.sale) > 0) {
                    return 'primary'
                } else if (parseFloat(this.value.sale) < 0) {
                    return 'danger'
                } else {
                    if (parseFloat(this.value.cost) == 0) {
                        return 'dark'
                    } else {
                        return 'info'
                    }
                }
            }
        },
        postit_icon() {
            if (this.busy) {
                return 'fa fa-spinner fa-spin text-white mr-1'
            } else {
                if (this.value.posted) {
                    return 'fa fa-stack-overflow mr-1'
                } else {
                    if (parseFloat(this.value.sale) == 0 && parseFloat(this.value.cost) == 0) {
                        return 'fa fa-exclamation-circle mr-1'
                    } else {
                        return 'fa fa-paper-plane mr-1'
                    }

                }
            }
        },
        postit_label() {
            if (this.busy) {
                if (this.value.posted) {
                    return 'Posting to Ledgers'
                }
            } else {
                if (this.value.posted) {
                    return 'Invoiced on ' + this.items.map(l => l.ref).sort().join(',')
                } else {
                    if (parseFloat(this.value.sale) > 0) {
                        return 'Invoice It'
                    } else if (parseFloat(this.value.sale) < 0) {
                        return 'Credit It'
                    } else {
                        if (parseFloat(this.value.cost) == 0) {
                            return 'User Error?'
                        } else if (parseFloat(this.value.cost) > 0) {
                            return 'BL Invoice'
                        } else {
                            return 'BL Credit'
                        }
                    }
                }
            }
        },
    },
    watch: {
        tabindex: {
            immediate: true,
            async handler(newVal, oldVal) {
                if (newVal == 1) {
                    await this.renderit()
                }
            }
        },
        perline: {
            immediate: true,
            async handler(newVal, oldVal) {
                await this.renderit()
            }
        },
        refno: {
            immediate: true,
            async handler(newVal, oldVal) {
                await this.load_bookingform(newVal)
            }
        },
        value: {
            immediate: true,
            async handler(newVal, oldVal) {
                this.travellers = []
                this.creditno = null
                this.ticketno = null
                this.routing = null
                this.confermano = []
                this.lines = newVal.lines
                this.tabindex = 0
                this.perline = false
                let refnos = newVal.referenceno.split(",")
                this.refno_options = []
                for (var i = 0; i < refnos.length; i++) {
                    this.refno_options.push({ id: refnos[i], label: refnos[i] })
                }

            }
        },
        page: {
            async handler(newVal, oldVal) {
                if (newVal) {
                    if (newVal <= this.ss.length) {
                        this.item = this.ss[newVal - 1];

                        if (this.item.data) {
                            this.data = JSON.parse(this.item.data);
                            this.SL = [];
                            this.SL.push({ ...this.data.SL[0] });
                            delete this.SL[0].items;
                        }
                    }
                }
            },
        }
    },
    methods: {
        icontype(value) {
            let result = "fa fa-arrows-h"
            switch (value) {
                case "AIR":
                    result = "fa fa-plane text-primary"
                    break;
                case "CAR":
                    result = "fa fa-car text-info"
                    break;
                case "HTL":
                    result = "fa fa-bed text-orange"
                    break;
                case "EMD":
                    result = "fa fa-user-plus text-purple"
                    break;
                case "XFR":
                    result = "fa fa-map-marker text-dark"
                    break;
                case "RAIL":
                    result = "fa fa-train text-danger"
                    break;
            }
            return result
        },
        onlyascii(value) {
            // A SPECIFIC REPLACE
            value = value.split('b').join('')
            value = value.normalize('NFD').replace(/([\u0300-\u036f]|[^\x20-\x7E])/g, '')
            return value
        },
        cliplines() {
            try {
                window.navigator.clipboard.writeText(this.value.referenceno);
            } catch (error) {
                console.log(error)
            }
        },
        linesAll(evt) {
            const list = this.allLinesChecked
                ? []
                : this.value.lines.slice(0, this.value.lines.length);
            this.lines = list;
        },
        toggleLine(evt, index) {
            console.log("toggleLine", evt, index);

            const savedIndex = this.savedIndex;
            this.savedIndex = index;

            // If this is the first pass or no shift key was
            // pressed, just bail.
            if (savedIndex === null || !evt.shiftKey) return;

            // Shift-clicked the same message :-/
            if (index === savedIndex) return;

            // Get the subset of the message list between the
            // two indicies.
            // console.time("toggle range");
            const subset = this.items.slice(
                Math.min(index, savedIndex),
                Math.max(index, savedIndex) + 1
            );
            // Determine the operation based on the checked state
            // of the clicked checkbox.
            const toggleFn = evt.currentTarget.checked
                ? addCheckedSubset
                : removeCheckedSubset;

            this.lines = toggleFn(this.lines, subset);
            console.log("these are checked", this.lines);
            // console.timeEnd("toggle range");
        },
        addLine() {
            let _copy = { ...this.lines[this.lines.length - 1] }
            this.lines.push(_copy)
        },
        async renderit() {

            console.log('renderit')
            this.busy = true
            this.draft = true

            let quote = { ... this.value }
            quote.lines = this.lines //.filter(o => o.cost != 'N/A')

            let variables = {
                data: JSON.stringify(quote),
                prefix: this.prefix,
                creditno: this.creditno,
                ticketno: this.ticketno,
                routing: this.routing,
                confermano: this.confermano.length > 0 ? this.confermano.join(",") : null,
                perline: this.perline,
                apply: false
            };
            try {
                const response = await this.$apollo.query({
                    query: gql`
                    query ihold_draftinvoice(
                      $data: String
                      $prefix: String,
                      $creditno: String
                      $ticketno: String
                      $routing: String
                      $confermano: String
                      $perline: Boolean
                      $apply: Boolean
                  ) {
                    ihold_draftinvoice(
                        data: $data
                        prefix: $prefix
                        creditno: $creditno
                       ticketno: $ticketno
                       routing: $routing
                        confermano: $confermano
                        perline: $perline
                        apply: $apply
                      ) {
                        id
                        ref
                        refcredit
                        to
                        address
                        dateref
                        slac
                        agent
                        yourref
                        booker
                        eventname
                        vatregion
                        terms
                        credit
                        data
                        saleexvat
                        salevat
                        saletotal
                        document {
                          fields {
                            key
                            label
                            class
                          }
                          items
                        }
                        message
                        level
                      }
                  }
                  `,
                    variables,
                    fetchPolicy: "no-cache",
                });

                this.items = response.data.ihold_draftinvoice;
                let sset = this.items
                this.ss = sset

                this.item = { ref: "" }
                if (this.ss.length > 0) {

                    this.item = this.ss[0];
                    if (this.item.salevat == 0) { this.item.salevat = "" }

                    this.SL = []

                    if (this.item.data) {
                        this.data = JSON.parse(this.item.data);
                        this.SL.push({ ...this.data.SL[0] });
                        delete this.SL[0].items;
                    }
                }

            } catch (error) {
                console.log(error);
            }
            this.draft = false
            this.busy = false
        },
        async postit() {
            console.log('postit', this.value)

            let tags = this.item.tags == null ? {} : JSON.parse(this.item.tags)
            if (this.mifields.length > 0) {
                for (var k = 0; k < this.mifields.length; k++) {
                    tags[this.mifields[k].key] = this.mifields[k].value;
                }
            }

            let requirements = await this.mifields_requirement()
            if (requirements.length > 0) {
                this.message_saveit =
                    "<span class='text-danger'>" +
                    requirements.slice(0, -1) +
                    " required field(s). </span>";
                this.busy = false;
                return;
            } else {
                this.message_saveit = ""
            }

            this.busy = true;

            let quote = { ... this.value }
            quote.lines = this.lines // .segments.filter(o => o.fare != 'N/A')

            let variables = {
                data: JSON.stringify(quote),
                prefix: this.prefix,
                creditno: this.creditno,
                ticketno: this.ticketno,
                routing: this.routing,
                confermano: this.confermano.length > 0 ? this.confermano.join(",") : null,
                perline: this.perline,
                apply: true
            };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.query({
                    query: gql`
                    query ihold_draftinvoice(
                      $data: String
                      $prefix: String
                      $creditno: String
                      $ticketno: String
                      $routing: String
                      $confermano: String
                      $perline: Boolean
                      $apply: Boolean
                  ) {
                    ihold_draftinvoice(
                        data: $data
                        prefix: $prefix
                        creditno: $creditno
                        ticketno: $ticketno
                        routing: $routing
                        confermano: $confermano
                        perline: $perline
                        apply: $apply
                      ) {
                        id
                        ref
                        refcredit
                        to
                        address
                        dateref
                        slac
                        agent
                        yourref
                        booker
                        eventname
                        vatregion
                        terms
                        credit
                        data
                        saleexvat
                        salevat
                        saletotal
                        document {
                          fields {
                            key
                            label
                            class
                          }
                          items
                        }
                        message
                        level
                      }
                  }
                  `,
                    variables,
                    fetchPolicy: "no-cache",
                });

                this.items = response.data.ihold_draftinvoice;
                let sset = this.items
                this.ss = sset

                this.item = { ref: "" }
                if (this.ss.length > 0) {

                    this.item = this.ss[0];
                    if (this.item.salevat == 0) { this.item.salevat = "" }

                    this.SL = []

                    if (this.item.data) {
                        this.data = JSON.parse(this.item.data);
                        this.SL.push({ ...this.data.SL[0] });
                        delete this.SL[0].items;
                    }
                }

            } catch (error) {
                console.log(error);
            }
            this.$emit("postit");

            this.busy = false;
        },
        async load_bookingform(id) {
            if (!id) {
                id = this.refno_options[0]
            }
            console.log(id)
            let variables = {
                id
            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query bookingforms($id: String) {
                        bookingforms(id: $id) {
                            id
                            payby
                            reason
                            date
                            datetravel
                            blac
                            value
                            deploymentid
                            currency
                            country
                            comments
                            event
                            slac
                            charge
                            invoiceno
                            yourref
                            agent
                            status
                            created_at
                            created_by
                            updated_at
                            updated_by
                        }
                        }
                    `,
                    variables,
                });

                if (response.data.bookingforms.length > 0) {
                    this.notes = response.data.bookingforms[0].comments;
                }

            } catch (error) {
                console.log(error);
            }

        }
    }
};
</script>

<style></style>